import { AxiosError } from 'axios';
import { useCustomMutation } from '../utils/useCustomMutation';
import { POST_ADD_SUBJECT_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================

export interface PostSubjectResponse {}

export interface PostSubjectRequest {
  subjectUuid: string;
  paperUuid: string;
  specialConsiderationType: string;
  reason: string;
  explanation: string;
  examDate: string;
  requestUuid: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostAddSubject = ({ onSuccess, onError }: Input = {}) => {
  const postExamLevels = async (reqBody: PostSubjectRequest) => {
    const res = await axiosClient.post<PostSubjectResponse[]>(
      POST_ADD_SUBJECT_URL(reqBody.requestUuid),
      {
        subjectUuid: reqBody.subjectUuid,
        paperUuid: reqBody.paperUuid,
        specialConsiderationType: reqBody.specialConsiderationType,
        reason: reqBody.reason,
        explanation: reqBody.explanation,
        examDate: reqBody.examDate,
      }
    );
    return res.data;
  };

  return useCustomMutation(postExamLevels, {
    onSuccess,
    onError,
  });
};
